import { DashboardId } from '@blisspointmedia/bpm-types/dist/dashboarding';
import { DashboardCard } from '../dashboard-types';
import { useMirroredValue, usePublishMirroredValue } from './useMirroredValue';

const BUFFERED_LAYOUT_SCOPE = 'dashboard-layout-buffer';

/**
 * The layout on screen, unsaved changes included, mirrored from DashboardBuilder (which owns the
 * buffer) to AgentDrawer (which grounds the agent). Without it the agent sees the SAVED layout, so
 * after "move the table to the top" the next turn still lists the old order and a second move lands
 * in the wrong place.
 *
 * `null` while no builder has published one — the drawer then falls back to the saved dashboard.
 */
export const useBufferedLayout = (
  company: string,
  dashboardId: DashboardId | null
): DashboardCard[] | null =>
  useMirroredValue<DashboardCard[]>(BUFFERED_LAYOUT_SCOPE, company, dashboardId);

export const usePublishBufferedLayout = (
  company: string,
  dashboardId: DashboardId | null,
  cards: DashboardCard[]
): void => usePublishMirroredValue(BUFFERED_LAYOUT_SCOPE, company, dashboardId, cards);
